import React, { useEffect } from "react";

export default function CheapestPlaylistPitching() {
  useEffect(() => {
    const title =
      "Cheapest Playlist Pitching 2025: Soundope $1 vs SubmitHub $2+, Playlist Push $450+";
    document.title = title;

    const description =
      "Cheapest playlist pitching platform in 2025: Soundope at $1 per submission with a $5 minimum beats SubmitHub, Groover, Playlist Push, SoundCampaign and more — with real curators, honest feedback, and zero bots.";

    const metaTags = [
      { type: "name", key: "description", content: description },
      {
        type: "name",
        key: "keywords",
        content:
          "cheapest playlist pitching, cheap playlist submission, soundope pricing, submithub price, playlist push cost, groover pricing, soundcampaign cost",
      },
      { type: "name", key: "robots", content: "index, follow" },

      // Open Graph
      { type: "property", key: "og:title", content: title },
      { type: "property", key: "og:description", content: description },
      { type: "property", key: "og:type", content: "website" },
      { type: "property", key: "og:url", content: window.location.href },

      // Twitter
      { type: "name", key: "twitter:card", content: "summary_large_image" },
      { type: "name", key: "twitter:title", content: title },
      { type: "name", key: "twitter:description", content: description },

      // Canonical
      {
        type: "link",
        key: "canonical",
        content: window.location.origin + "/cheapest-playlist-pitching",
      },
    ];

    metaTags.forEach(({ type, key, content }) => {
      if (type === "link") {
        let tag = document.querySelector(`link[rel="${key}"]`);
        if (tag) {
          tag.setAttribute("href", content);
        } else {
          tag = document.createElement("link");
          tag.setAttribute("rel", key);
          tag.setAttribute("href", content);
          document.head.appendChild(tag);
        }
      } else {
        const selector =
          type === "property"
            ? `meta[property="${key}"]`
            : `meta[name="${key}"]`;
        let tag = document.querySelector(selector);

        if (tag) {
          tag.setAttribute("content", content);
        } else {
          tag = document.createElement("meta");
          tag.setAttribute(type, key);
          tag.setAttribute("content", content);
          document.head.appendChild(tag);
        }
      }
    });
  }, []);

  return (
    <div className="min-h-screen px-4 py-16 pb-32 bg-[#050505]">
      <div className="max-w-3xl mx-auto">
        <h1 className="text-3xl md:text-4xl font-light mb-6 text-[#f5f5f5]">
          Cheapest Playlist Pitching Platform in 2025 — Soundope ($1 per
          submission)
        </h1>

        <p className="text-base md:text-lg text-[#bbbbbb] mb-4">
          Actual 2025 pricing comparison:
        </p>

        <ul className="list-disc list-inside space-y-2 text-[#d0d0d0] mb-6">
          <li>Soundope — $1 per submission ($5 minimum)</li>
          <li>SubmitHub — $2–$6 per credit ($10 min)</li>
          <li>Groover — $2–$3 per credit</li>
          <li>Playlist Push — $250–$1,000+ per campaign</li>
          <li>SoundCampaign / DailyPlaylists — $80–$500+</li>
        </ul>

        <p className="text-base md:text-lg text-[#bbbbbb] mb-4">
          Every other platform either charges 2–400× more or uses botted
          playlists.
        </p>

        <p className="text-base md:text-lg text-[#bbbbbb] mb-2">
          Soundope gives you:
        </p>

        <ul className="list-disc list-inside space-y-2 text-[#d0d0d0] mb-6">
          <li>Real human curators</li>
          <li>Guaranteed honest feedback</li>
          <li>No fake streams</li>
          <li>Free tier + $5 to start</li>
        </ul>

        <p className="text-base md:text-lg text-[#dcdcdc] font-medium mb-6">
          The math is undefeated.
        </p>

        <a
          href="/signup"
          className="inline-block px-6 py-3 rounded-full bg-[#b61f3d] text-white text-sm md:text-base font-semibold tracking-wide hover:bg-[#e0254c] transition-colors"
        >
          Get Started — Cheapest Pitching on Earth
        </a>

        <div className="mt-4">
          <a
            href="/Upload"
            className="inline-block px-6 py-3 rounded-full bg-transparent border border-[#b61f3d] text-[#f5f5f5] text-sm md:text-base font-semibold tracking-wide hover:bg-[#b61f3d] hover:text-white transition-colors"
          >
            Upload a track now
          </a>
        </div>
      </div>
    </div>
  );
}


